import { createPolicy } from "../base-policy/base-policy";
/**
 * Function to create a policy that returns an empty string as TrustedHTML.
 * @param policyName Name of the policy. Should be unique.
 * @param trustedTypesApi Optional trusted types API. Given that it is only available in the browser we should specify one for unit testing.
 * @returns the ConstantsPolicy for HTML.
 */
export const createEmptyStringPolicyHtml = (
  policyName: string,
  trustedTypesApi?: any
) => {
  return createPolicy(
    policyName,
    {
      createHTML: (_: string) => {
        return "";
      },
    },
    trustedTypesApi
  );
};
/**
 * Production empty string policy for HTML.
 */
// eslint-disable-next-line
export const emptyStringPolicyHTML = /*#__PURE__*/ createEmptyStringPolicyHtml(
  "emptyStringPolicyHTML"
);

export const createEmptyStringPolicyURL = (
  policyName: string,
  trustedTypesApi?: any
) => {
  return createPolicy(
    policyName,
    {
      createScriptURL: (_: string) => {
        return "";
      },
    },
    trustedTypesApi
  );
};
/**
 * Production empty string policy for URL.
 */
// eslint-disable-next-line
export const emptyStringPolicyURL = /*#__PURE__*/ createEmptyStringPolicyURL(
  "emptyStringPolicyURL"
);
